<template>
  <v-app-bar dense app flat class="primary white--text px-3">
    <!-- Botón Menú -->
    <v-btn
      class="mr-3"
      color="#2E7D32"
      dark
      rounded
      elevation="2"
      @click="abrirDrawer"
      aria-label="Abrir menú lateral"
    >
      <v-icon left color="white">mdi-menu</v-icon>
      <span class="white--text font-weight-medium">Menú</span>
    </v-btn>

    <!-- Botón Inicio con ícono de casa -->
    <router-link to="/began" class="text-none">
      <v-btn
        color="#2E7D32"
        dark
        rounded
        elevation="2"
        aria-label="Ir a la página de inicio"
      >
        <v-icon left color="white">mdi-home</v-icon>
      </v-btn>
    </router-link>

    <!-- Título centrado -->
    <v-spacer></v-spacer>
    <v-toolbar-title
      class="font-weight-bold text-subtitle-1 text-center text-truncate"
      style="max-width: 250px"
      v-text="titulo_app"
    />
    <v-spacer></v-spacer>
  </v-app-bar>
</template>
   
<script>
export default {
  name: 'EToolbar',
  computed: {
    titulo_app() {
      return this.$store.state.ui.titulo_app
    },
    toolbar() {
      return this.$store.state.ui.toolbar
    },
  },
  methods: {
    // actualiza el estado del drawer cada vez que se hace click sobre el ícono de 'menu'
    abrirDrawer() {
      this.$store.commit('ui/updateEDrawer', !this.$store.state.ui.e_drawer)
    },
  },
}
</script>
<style scoped>
.text-none {
  text-decoration: none;
}
</style>
